import React, { useState, useRef, useEffect } from "react";
import { FaCheck, FaPlus, FaMinus } from "react-icons/fa6";
import { Input } from "../../controls";
import Menu from "@mui/material/Menu"; // Import Menu component from Material-UI
import MenuItem from "@mui/material/MenuItem"; // Import MenuItem component from Material-UI
import { HiOutlineCheck } from "react-icons/hi";
import "./IconMenuOptionStyles.scss";

const IconMenuOption = ({
  menuIcon,
  options,
  showMenuOptions,
  handleCloseMenuOptions,
  onClickFilterOption,
  name,
  search = false,
  persistedData,
  multipleFilterAllowed = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState("");
  const [multipleFilterSelectedItem, setMultipleFilterSelectedItem] = useState(
    []
  );
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    //update to have data in state, otherwise it will be empty

    if (!multipleFilterAllowed) {
      setSelectedItem(persistedData);
    }
    if (multipleFilterAllowed) {
      setMultipleFilterSelectedItem(persistedData);
    }
  }, [persistedData]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    if (persistedData?.length > 0 && multipleFilterAllowed) {
      // remove the selection from the list if filter not applied for that item;
      setMultipleFilterSelectedItem(persistedData);
      setAnchorEl(null);
      setFilterValue("");
    }

    if (persistedData?.length === 0 && multipleFilterAllowed) {
      //this is to reset the state of multipleFilterSelectedItem if dropdown is closed without applying filter
      setAnchorEl(null);
      setFilterValue("");
      setMultipleFilterSelectedItem([]);
    } else {
      setAnchorEl(null);
      setFilterValue("");
    }
  };

  const handleClickOption = (item) => {
    setSelectedItem(item);
    console.log(item);
    onClickFilterOption(item);
    handleClose();
  };

  const handleMultipleFilterClickOption = (item) => {
    // Check if item is already in the array
    const isAlreadySelected = multipleFilterSelectedItem.includes(item);

    // If item is already selected, remove it; otherwise, add it
    const updatedFilters = isAlreadySelected
      ? multipleFilterSelectedItem.filter((filterItem) => filterItem !== item)
      : [...multipleFilterSelectedItem, item];
    setMultipleFilterSelectedItem(updatedFilters);
    // onClickFilterOption(updatedFilters);
    // handleClose();
  };

  const handleOnClickDone = () => {
    onClickFilterOption(multipleFilterSelectedItem);
    handleClose();
  };

  const handleClear = () => {
    setSelectedItem("");
    setMultipleFilterSelectedItem([]);
    onClickFilterOption(); //call the api
    handleClose();
  };

  // Filter options based on filterValue
  const filteredOptions = options?.filter((item) =>
    item[name].toLowerCase().includes(filterValue?.toLowerCase())
  );

  return (
    <div className="icon_menu_option--wrapper">
      <div className="icon_menu_option--menuIcon" onClick={handleClick}>
        <span className="menu">{menuIcon}</span>
        {/* {selectedItem || filterValue ? (
          <span className="red-indicator" />
        ) : null} */}
        <span
          className={`filter-indicator ${
            (selectedItem ||
              multipleFilterSelectedItem?.length > 0 ||
              filterValue) &&
            "active"
          } `}
        >
          {selectedItem ||
          multipleFilterSelectedItem?.length > 0 ||
          filterValue ? (
            <FaMinus
              className="plus-icon"
              size={8}
              onClick={(e) => {
                e.stopPropagation();
                handleClear();
              }}
            />
          ) : (
            <FaPlus className="minus-icon" size={8} />
          )}
        </span>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div className={`search-block ${search ? null : "d-none"}`}>
          <Input
            value={filterValue}
            placeholder={"search language"}
            onKeyDown={(e) => e.stopPropagation()}
            onChange={(e) => {
              return setFilterValue(e.target.value);
            }}
          />
        </div>
        {showMenuOptions &&
          filteredOptions?.map((item) => (
            <MenuItem
              key={item._id}
              onClick={() => {
                multipleFilterAllowed
                  ? handleMultipleFilterClickOption(item)
                  : handleClickOption(item);
              }}
              className={`option-content.active ${
                // selectedItem === item ? "active" : ""
                selectedItem?._id === item._id ? "active" : ""
              }`}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <span className="menu-list-item-title">{item[name]}</span>
                {/* {selectedItem?._id === item._id && <HiOutlineCheck />} */}

                {/* {(selectedItem?._id === item._id ||
                  (!selectedItem?._id &&
                    selectedItem?.name === item[name])) && <HiOutlineCheck />} */}

                {(selectedItem?._id === item._id ||
                  (!selectedItem?._id &&
                    selectedItem?.name === item[name])) && <HiOutlineCheck />}

                {multipleFilterAllowed &&
                  multipleFilterSelectedItem.some(
                    (selected) => selected._id === item._id
                  ) && <HiOutlineCheck />}
              </div>
            </MenuItem>
          ))}
        {/* <MenuItem onClick={handleClear} className="clear-block">
          Clear
        </MenuItem> */}
        {multipleFilterAllowed && (
          <MenuItem onClick={handleOnClickDone} className="submit-block">
            Apply Filter
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default IconMenuOption;
